import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LayoutService } from 'src/app/services/layout.service';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-top15-report-modal',
    templateUrl: './top15-report-modal.component.html',
    styleUrls: ['./top15-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DecimalPipe]
})
export class Top15ReportModalComponent implements OnInit {
  reportData: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.generateReport();
  }

  generateReport() {
    const products = this.layoutService.planogramItems;
    const actualFacingCounts = this.layoutService.getActualFacingCounts();
    
    const totalProducts = products.size;
    const totalSales = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.sales, 0);
    const totalSalesQty = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.salesQty, 0);
    const totalFacings = Array.from(actualFacingCounts.values()).reduce((sum, count) => sum + count, 0);

    this.reportData = Array.from(products.values())
      .map(product => {
        const productSales = product.salesData.sales;
        const productSalesQty = product.salesData.salesQty;
        const productFacings = actualFacingCounts.get(product.productId) || 0;
        const volumeContribution = (100 / totalSalesQty) * productSalesQty;
        const planoFacings = totalFacings > 0 ? (100 / totalFacings) * productFacings : 0;
        const volumeVariance = Math.abs(planoFacings) - Math.abs(volumeContribution);

        let varianceColor = 0;

        if (Math.abs(volumeVariance) > 3 && Math.abs(volumeVariance) < 5) {
          varianceColor = 1;
        } else if (Math.abs(volumeVariance) >= 5) {
          varianceColor = 2;
        }

        return {
          name: product.description,
          size: `${product.uos} ${product.unit}`,
          segment: product.categoryLevel2,
          salesContribution: (100 / totalSales) * productSales,
          volumeContribution: volumeContribution,
          planoFacings: planoFacings,
          volumeVariance: volumeVariance,
          varianceColor: varianceColor
        };
      })
      .sort((a, b) => b.volumeContribution - a.volumeContribution)
      .slice(0, 15);
  }

  close() {
    this.activeModal.close();
  }
}
